<div class="p-4 overflow-auto h-[85vh]">
    <div class="flex justify-between -mt-4">
        <h2 class="text-xl font-semibold">Departments</h2>
        <p-button icon="pi pi-plus" label="Add Department" (click)="openAddModal()" class="mb-3"></p-button>
    </div>

    <p-table [value]="departments" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadDepartments($event)" [loading]="loading">
        <ng-template pTemplate="header">
            <tr>
                <th>Department Name</th>
                <th>Department ID</th>
                <th>Client ID</th>
                <th>Is Public</th>
                <th>Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-dept>
            <tr>
                <td>{{ dept.dept_name }}</td>
                <td>{{ dept.dept_id }}</td>
                <td>{{ dept.client_id }}</td>
                <td>{{ dept.isPublic ? 'Yes' : 'No' }}</td>
                <td>
                    <div (click)="setDepartmentData(dept)">
                        <p-menu [tabindex]="undefined" #menu [model]="departmentActionItem" [popup]="true"
                            appendTo="body"></p-menu>
                        <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="loading">
            <tr>
                <td colspan="5" class="text-center"><p-progressSpinner></p-progressSpinner></td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<ng-container *ngIf="displayAddModal">
    <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
        <app-create-department [clientId]="clientId" [centers]="centers" (reload)="reload()" (close)="closeAddModal()">
        </app-create-department>
    </p-dialog>
</ng-container>

<ng-container *ngIf="showEditDepartment">
    <p-dialog [(visible)]="showEditDepartment" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
        <app-create-department [clientId]="clientId" [type]="'Update'" [centers]="centers"
            [departmentDataToEdit]="departmentDataToEdit" (reload)="reload()" (close)="showEditDepartment = false">
        </app-create-department>
    </p-dialog>
</ng-container>


<ng-container *ngIf="showDeleteDepartment">
    <p-dialog [(visible)]="showDeleteDepartment" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
        <app-delete-department [clientId]="clientId" (reload)="reload()" [departmentDataToEdit]="departmentDataToEdit"
            (close)="showDeleteDepartment = false"></app-delete-department>
    </p-dialog>
</ng-container>